import Swiper from 'swiper'
import { Navigation, Pagination } from 'swiper/modules';

// Initialize all .swiper-features instances
class FeaturesSlider {
  constructor(){
    this.init();
  }
  init(){
    const swipers = new Swiper('.swiper-features', {
    modules: [Navigation, Pagination],
    loop: true,
    slidesPerView: 1.1,
    spaceBetween: 24,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      576: { slidesPerView: 1.35 },
      768: { slidesPerView: 2.2 },
      992: { slidesPerView: 2.5 },
      1200: { slidesPerView: 1.5 },
      1400: { slidesPerView: 2.2 },
    },
    on: {
      init(this: Swiper) {
        setTimeout(() => equalizeSlideHeights(this.el), 50);
      },

      slideChangeTransitionStart(this: Swiper) {
        const prevIndex = this.previousIndex;
        const activeIndex = this.activeIndex;
        const realLength = this.slides.length;

        const isLoopingForward =
          (activeIndex > prevIndex && !(activeIndex === 0 && prevIndex === realLength - 1)) ||
          (activeIndex === 0 && prevIndex > activeIndex);

        if (isLoopingForward) {
          const prevSlide = this.slides[prevIndex] as HTMLElement | undefined;
          if (prevSlide) {
            prevSlide.classList.add('fading-out');
            void prevSlide.offsetWidth;
            setTimeout(() => {
              prevSlide.classList.remove('fading-out');
            }, 250);
          }
        } else {
          // Backward nav: fade in the current slide
          const activeSlide = this.slides[activeIndex] as HTMLElement | undefined;
          if (activeSlide) {
            activeSlide.classList.add('fading-in');
            activeSlide.classList.remove('fading-in-active'); // reset just in case

            // Force reflow, then trigger fade-in transition
            void activeSlide.offsetWidth;

            // Now trigger the fade-in transition
            activeSlide.classList.add('fading-in-active');

            // Clean up
            setTimeout(() => {
              activeSlide.classList.remove('fading-in');
              activeSlide.classList.remove('fading-in-active');
            }, 250);
          }
        }
      },

      slideChangeTransitionEnd(this: Swiper) {
        equalizeSlideHeights(this.el);
      },
    }
  });

  // Equalize slide heights per Swiper container
  function equalizeSlideHeights(container: HTMLElement | null): void {
    if (!container) return;

    const wrapper = container.querySelector('.swiper-wrapper') as HTMLElement | null;
    const slides = container.querySelectorAll<HTMLElement>('.swiper-slide');

    if (!wrapper || slides.length === 0) return;

    // Temporarily remove Swiper transform to get accurate height
    const originalTransform = wrapper.style.transform;
    wrapper.style.transform = 'none';

    // Reset heights
    slides.forEach(slide => {
      slide.style.height = 'auto';
    });

    // Determine the tallest slide
    let maxHeight = 0;
    slides.forEach(slide => {
      maxHeight = Math.max(maxHeight, slide.scrollHeight);
    });

    // Apply uniform height
    slides.forEach(slide => {
      slide.style.height = `${maxHeight}px`;
    });

    // Restore Swiper transform
    wrapper.style.transform = originalTransform;
  }

  // Re-apply on resize for all .swiper-features
  let resizeTimeout: number;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = window.setTimeout(() => {
      document.querySelectorAll<HTMLElement>('.swiper-features').forEach(container => {
        equalizeSlideHeights(container);
      });
    }, 150);
  });

  }
}

export default FeaturesSlider;